<template>
  <v-flex v-if="tip == 'get'">
    
    <v-text-field
      :label="$t('Accounting-Code')"
      :disabled="aktifmi"
      v-model="val"
      id="searchMuhasebeKod"
      :dont-fill-mask-blanks="maskFill"
      :hint="placeText"
      persistent-hint
      return-masked-value
      :search-input.sync="searchMuhasebeKodSync"
      @click="maskFillActive()"
    >
    </v-text-field>
  </v-flex>
  <v-flex v-else>
   
    <v-text-field
      :label="$t('Accounting-Code')"
      :disabled="aktifmi"
      v-model="val"
      :search-input.sync="searchMuhasebeKodSync"
      @blur="controlText"
      :mask="`${mask}`"
      id="searchMuhasebeKod"
      :dont-fill-mask-blanks="maskFill"
      :hint="placeText"
      persistent-hint
      return-masked-value
      @click="maskFillActive()"
    >
      <template v-if="addNewMainCode" v-slot:append-outer>
        <v-icon color="info" @click="addNew()">add_box</v-icon>
      </template>
    </v-text-field>
  </v-flex>
</template>

<script>
import auth from "@/api/auth";

export default {
  props: {
    value: {},
    aktifmi: {
      type: Boolean,
    },
    controlValue: {},
    tip: {},
  },
  methods: {
    addNew() {
      this.$emit("addAccoutingCode");
    },
    controlAccountID(val) {
      console.log('2');
      var params = {
        CompanyID: this.credentials.MuhasebeSirketNo,
        Code: val,
      };
      this.$http
        .post(
          auth.API_URL + "api/AccountingCodes/GetAccountingCodeID",
          params,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          }
        )
        .then(
          (response) => {
            if (response.body.CodeID == 0) {
              this.addNewMainCode = true;
            } else {
              this.addNewMainCode = false;
            }
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable";
              this.snackbar = true;
            } else {
              this.text1 = "Service Unavailable";
              this.snackbar = true;
            }
          }
        );
    },
    maskFillActive() {
      this.maskFill = false;
    },
    controlText() {
      var control=true;
      this.credentials.MuhasebeSirketler.forEach((element) => {
        if (element.CompanyID == this.credentials.MuhasebeSirketNo) {
          if (!element.SingleOrderAccounting) {
            
          control=false;
          }
            }
       
      })
      if (control==false)
      {
        return;
      }
      
      if (document.getElementById("searchMuhasebeKod").value.length > 0) {
       
        var controlValue = document
          .getElementById("searchMuhasebeKod")
          .value.split(".");
        var controlMask = this.mask.split(".");
        for (let index = 0; index < controlValue.length; index++) {
          const element = controlValue[index];
          if (element.length != 0) {
            if (element.length != controlMask[index].length) {
              this.placeText = this.mask + " formatında giriş yapmalısınız.";
              this.val = null;
              this.maskFill = false;
            } else {
              this.placeText = " ";
              this.maskFill = false;
            }
          } else {
            
            var cropText = this.val.substring(
              this.val.length - 1,
              this.val.length
            );
            if (cropText == ".") {
             
              this.val = this.val.substring(0, this.val.length - 1);
            }
            this.maskFill = true;
          }
        }
      }
    },
  },
  computed: {
    val: {
      get: function () {
       
        if (this.value == null) {
          this.credentials.MuhasebeSirketler.forEach((element) => {
            if (element.SingleOrderAccounting) {
            
              if (element.CompanyID == this.credentials.MuhasebeSirketNo) {
                var _mask = "NNN.";
                
                var maskValue = element.SingleOrderPattern.split("+");
                for (let index = 0; index < maskValue.length; index++) {
                  const element = maskValue[index];
                  if (maskValue[index].length > 0) {
                    const result = this.maskValueList.find(
                      ({ value }) => value == maskValue[index]
                    );
                    if (result != undefined) {
                      _mask += result.text + ".";
                    }
                  }
                }
                _mask = _mask.substring(0, _mask.length - 1);
                this.mask = _mask;
                return this.value;
              } else {
                return this.value;
              }
            } else {
             
              return this.value;
            }
          });
        } else {
         
          return this.value;
        }
      },
      set: function (newValue) {
       
        this.$emit("input", newValue);
      },
    },
  },
  data() {
    return {
      addNewMainCode: false,
      search: null,
      maskFill: false,
      credentials: JSON.parse(window.localStorage.getItem("credentials")),
      muhasebeItems: [],
      placeText: null,
      searchMuhasebeKodSync: null,
      counter: 0,
      mask: "",
      maskValueList: [
        {
          value: 1,
          text: "N",
        },
        {
          value: 2,
          text: "NN",
        },
        {
          value: 3,
          text: "NNN",
        },
        {
          value: 4,
          text: "NNNN"
        },
        {
          value: 5,
          text: "NNNNN",
        },
        {
          value: 6,
          text: "NNNNNN",
        },
        {
          value: 7,
          text: "NNNNNNN",
        },
        {
          value: 8,
          text: "NNNNNNNN",
        },
        {
          value: 9,
          text: "NNNNNNNNN",
        },
        {
          value: 10,
          text: "NNNNNNNNNN",
        },
      ],
    };
  },
  watch: {
    aktifmi() {
      if (this.aktifmi) {
        this.value = { CodeID: 0, CompanyID: 0, Code: null, CodeName: null };
      }
    },
    value: function (value) {
     
      if (value != null) {
        if (value.length == 4) {
          let searchText = value.substring(0, 3);
          this.controlAccountID(searchText);
        } else if (value.length == 3) {
          this.controlAccountID(value);
        } else if (value.length == 6) {
          this.controlAccountID(value);
        } else if (value.length == 7) {
          let searchText = value.substring(0, 6);
          this.controlAccountID(searchText);
        } else {
          this.addNewMainCode = false;
        }
      }
    },
  },
};
</script>

<style scoped>
.teksatir {
  display: contents;
}
</style>